<template>
    <div class="tsa-inputV2">
        <el-input placeholder="证书编号" v-model="input" :disabled="disabled" @input="inputFun" clearable size="small">
                        </el-input>
    </div>
</template>

<script>
export default {
    props: {
        placeholder: {
            type: String,
            default: '请输入'
        },
        disabled: {
            type: Boolean,
            default: false
        },
        value: {
            type: String | null,
            default: null
        }
    },
    watch: {
        value (val) {
            this.input = val
        }
    },
    data() {
        return {
            input: null
        }
    },
    methods: {
        inputFun () {
            this.$emit('input', this.input || null)
            this.$emit('on-input', this.input || null)
        }
    }
}
</script>

<style lang="scss" scoped>
    .tsa-inputV2 {
        :deep(.el-input) {
            .el-input__inner {
                border-radius: 6px;
                border: 1px solid #D4D6D9;
            }
            
        }
    }
</style>